import permissionsModule from "@/store/modules/permissions.module";


export class ItiPermissionService {


    public get permissions() {
      return permissionsModule.permissions;
    }

    public hasPermission(permission: string) {
      return this.permissions.findIndex((x) => x === permission) !== -1;
    }
}

export const itiPermissionService = new ItiPermissionService();
